<main class="w-full px-8 py-20 bg-white md:px-16">
    <div class="relative flex items-center">
        <button
            class="absolute z-50 flex items-center justify-center w-4 h-4 border rounded-full md:w-6 md:h-6 border-primary -left-5 md:-left-8"
            (click)="goback()">
            <mat-icon
                class="w-[5px] h-[3px] min-w-[5px] min-h-[3px] md:w-[7.5px] md:h-[4.5px] md:min-w-[7.5px] md:min-h-[4.5px] text-primary rotate-90"
                svgIcon="icons:arrow-icon">
            </mat-icon>
        </button>
        <h1 class="text-primary-black-01 title-6 md:title-3">Administración usuarios</h1>
    </div>

    <mat-form-field appearance="fill" class="w-full mt-5">
        <input
            matInput
            type="text"
            placeholder="Usuario/Rol"
            class="py-[18px]"
            [(ngModel)]="search"
            [patterns]="customPatterns"
            mask="0*"
            [dropSpecialCharacters]="false"
            maxlength="30"
            (keyup.enter)="buscarUsuarios()" />
        <mat-icon class="w-[16.67px] h-[15px] min-w-[16.67px] min-h-[15px] cursor-pointer" svgIcon="icons:buscar-icon" (click)="buscarUsuarios()">
        </mat-icon>
    </mat-form-field>

    <div class="flex justify-end my-3">
        <button class="flex items-center gap-3 text-primary-blue-01" (click)="openModalCrear()">
            <p class="text-button-12px">AGREGAR USUARIO</p>
            <mat-icon class="w-[9px] h-[9.5px] min-w-[9px] min-h-[9.5px] text-current" svgIcon="icons:usuario-icon"> </mat-icon>
        </button>
        <button class="flex items-center gap-3 ml-3 text-primary-blue-01" (click)="descargarExcel()">
            <p class="text-button-12px">DESCARGAR EXCEL</p>
            <mat-icon class="w-[16px] h-[16px] min-w-[16px] min-h-[16px] text-current" svgIcon="icons:excel-icon"> </mat-icon>
        </button>
    </div>

    <!-- ITEMS MOBILE -->
    <div class="grid grid-cols-1 gap-2 md:hidden sm:grid-cols-2" *ngIf="dataSource">
        <button
            (click)="handleClick(item)"
            *ngFor="let item of dataSource.data"
            [ngClass]="{
                'border-primary': hasItem(item),
                'border-gray-200': !hasItem(item)
            }"
            class="relative flex flex-col justify-start gap-1 p-4 text-left border-2 rounded-lg">
            <div class="absolute top-5 right-5">
                <svg *ngIf="!hasItem(item)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="7.5" stroke="#e5e7eb" />
                </svg>
                <svg *ngIf="hasItem(item)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="8" fill="#D52B1E" />
                    <path
                        d="M10.8847 5.2068C11.0256 5.07269 11.213 4.99855 11.4075 5.00002C11.602 5.00149 11.7883 5.07846 11.9272 5.21469C12.066 5.35092 12.1464 5.53575 12.1516 5.73018C12.1567 5.92461 12.0861 6.11343 11.9547 6.2568L7.96471 11.2468C7.8961 11.3207 7.81329 11.38 7.72124 11.4212C7.62919 11.4623 7.52978 11.4845 7.42896 11.4864C7.32814 11.4882 7.22798 11.4698 7.13447 11.432C7.04095 11.3943 6.95601 11.3381 6.88471 11.2668L4.23871 8.6208C4.16502 8.55214 4.10592 8.46934 4.06493 8.37734C4.02394 8.28534 4.00189 8.18603 4.00012 8.08533C3.99834 7.98462 4.01686 7.88459 4.05459 7.79121C4.09231 7.69782 4.14845 7.61298 4.21967 7.54176C4.29089 7.47055 4.37572 7.4144 4.46911 7.37668C4.5625 7.33896 4.66253 7.32043 4.76323 7.32221C4.86393 7.32399 4.96325 7.34603 5.05525 7.38702C5.14725 7.42801 5.23005 7.48712 5.29871 7.5608L7.39271 9.6538L10.8657 5.2288C10.872 5.2211 10.8776 5.21376 10.8847 5.2068Z"
                        fill="white" />
                </svg>
            </div>

            <p class="paragraph-4">RUT: {{ item.RUTDV }}</p>

            <p class="paragraph-4">Usuario (email): {{ item.CORREO }}</p>

            <p class="paragraph-4">Nombre de usuario: {{ item.NOMBRE }}</p>

            <p class="paragraph-4">Rol: {{ item.ROL }}</p>

            <button class="flex items-center gap-3 mt-3" (click)="openModalEditar(item)">
                <p class="text-primary-blue-01 text-button-12px">EDITAR</p>
                <mat-icon class="w-[10px] h-[10px] min-w-[10px] min-h-[10px]" svgIcon="icons:edit-icon"></mat-icon>
            </button>
        </button>
    </div>

    <!-- TABLE DESKTOP -->
    <div class="hidden w-full py-2 overflow-auto md:block custom-scroll">
        <table mat-table [dataSource]="dataSource" class="w-full" matSort>
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <!-- <mat-checkbox color="accent" (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox> -->
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox
                        color="accent"
                        (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="RUTDV">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="RUTDV" center class="px-1.5">RUT</th>
                <td mat-cell *matCellDef="let element" class="paragraph-5 px-1.5 text-left">
                    {{ element.RUTDV }}
                </td>
            </ng-container>
            <ng-container matColumnDef="CORREO">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="CORREO" class="px-1.5">USUARIO (EMAIL)</th>
                <td mat-cell *matCellDef="let element" class="paragraph-5 px-1.5 text-left">
                    {{ element.CORREO }}
                </td>
            </ng-container>
            <ng-container matColumnDef="NOMBRE">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="NOMBRE" class="px-1.5">NOMBRE DE USUARIO</th>
                <td mat-cell *matCellDef="let element" class="paragraph-5 px-1.5 text-left">
                    {{ element.NOMBRE }}
                </td>
            </ng-container>
            <ng-container matColumnDef="ROL">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="ROL" class="px-1.5">ROL</th>
                <td mat-cell *matCellDef="let element" class="paragraph-5 px-1.5 text-left">
                    {{ element.ROL }}
                </td>
            </ng-container>
            <ng-container matColumnDef="editar">
                <th mat-header-cell *matHeaderCellDef class="px-1.5">EDITAR</th>
                <td mat-cell *matCellDef="let element" class="paragraph-5 px-1.5 text-left">
                    <button class="flex items-center gap-3" (click)="openModalEditar(element)">
                        <p class="text-primary-blue-01 text-button-12px">EDITAR</p>
                        <mat-icon class="w-[10px] h-[10px] min-w-[10px] min-h-[10px]" svgIcon="icons:edit-icon"> </mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>
    <mat-paginator class="justify-end hidden md:flex text-primary" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons> </mat-paginator>
    <div class="flex justify-between py-5">
        <div class="flex flex-col gap-1">
            <p class="text-sm font-light">Usuarios</p>
            <span class="title-6">{{ selection.selected.length }}</span>
        </div>
        <button [disabled]="selection.selected.length === 0 || eliminandoDatos" color="primary" mat-flat-button (click)="openModalEliminar()">
            Dar Baja
        </button>
    </div>
</main>

<!-- Modal Crear -->
<div *ngIf="modalCrear" class="fixed inset-0 grid w-full h-full p-5 bg-opacity-50 bg-primary-black-01 z-999 place-items-center">
    <div
        class="w-full max-w-[481px] h-full max-h-[583px] md:max-h-[615px] bg-primary-white-01 rounded-2xl px-10 py-10 md:px-16 md:py-14 relative overflow-auto custom-scroll">
        <button
            class="absolute top-3 right-3 md:right-14 flex gap-3 items-center text-primary-blue-01 font-bold text-[10px]"
            (click)="closeModalCrear()">
            CERRAR
            <div class="flex items-center justify-center w-6 h-6 mx-auto border rounded-full border-primary-blue-01">
                <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
            </div>
        </button>
        <fuse-alert
            *ngIf="showAlertCrear"
            class="my-2"
            [name]="'alertCrear'"
            [appearance]="'soft'"
            [dismissible]="true"
            [showIcon]="false"
            [type]="alert.type"
            [@shake]="alert.type === 'error'">
            {{ alert.message }}
        </fuse-alert>
        <h1 class="font-bold text-center title-5">Agregar usuario</h1>
        <form class="mt-5" #formCrear="ngForm">
            <mat-form-field hideRequiredMarker class="w-full">
                <mat-label>Usuario</mat-label>
                <input
                    matInput
                    type="text"
                    placeholder="usuario@dominio.cl"
                    maxlength="50"
                    class="h-[26px]"
                    name="email"
                    [(ngModel)]="userModel.email"
                    pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.{1}[a-zA-Z]{2,8}$"
                    required
                    #email="ngModel" />
            </mat-form-field>
            <mat-form-field hideRequiredMarker class="w-full">
                <mat-label>Rut</mat-label>
                <input
                    matInput
                    type="text"
                    class="h-[26px]"
                    [(ngModel)]="userModel.rutDv"
                    name="rut"
                    placeholder="Ej. 12.345.678-9"
                    maxlength="12"
                    required
                    #rut="ngModel"
                    appRutValidation />
            </mat-form-field>
            <mat-form-field hideRequiredMarker class="w-full">
                <mat-label>Nombre usuario</mat-label>
                <input
                    matInput
                    type="text"
                    placeholder="Nombre usuario"
                    class="h-[26px]"
                    maxlength="50"
                    name="nombre"
                    [(ngModel)]="userModel.nombre"
                    pattern="^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]{1,50}$"
                    required
                    #nombreUsuario="ngModel" />
            </mat-form-field>

            <mat-form-field hideRequiredMarker appearance="fill" class="w-full">
                <mat-label>Rol</mat-label>
                <mat-select class="h-[54px]" required [(ngModel)]="userModel.rolId" #rol="ngModel" name="rol">
                    <mat-option *ngFor="let rol of roles" [value]="rol.id">
                        {{ rol.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <button
                mat-flat-button
                class="flex items-center justify-center w-48 h-10 mx-auto mt-5 btn-md btn-primary"
                [color]="'primary'"
                (click)="guardarUser()"
                [disabled]="guardandoUser || !formCrear.valid">
                <span>Guardar Cambios</span>
                <!-- <mat-progress-spinner *ngIf="loginForm.disabled" [diameter]="24" [mode]="'indeterminate'">
					</mat-progress-spinner> -->
            </button>
        </form>
    </div>
</div>

<!-- Modal Editar -->
<div *ngIf="modalEditar" class="fixed inset-0 grid w-full h-full p-5 bg-opacity-50 bg-primary-black-01 z-999 place-items-center">
    <div
        class="w-full max-w-[481px] h-full max-h-[608px] md:max-h-[640px] bg-primary-white-01 rounded-2xl px-10 py-10 md:px-16 md:py-14 relative overflow-auto custom-scroll">
        <button
            class="absolute top-3 right-3 md:right-14 flex gap-3 items-center text-primary-blue-01 font-bold text-[10px]"
            (click)="closeModalEditar()">
            CERRAR
            <div class="flex items-center justify-center w-6 h-6 mx-auto border rounded-full border-primary-blue-01">
                <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
            </div>
        </button>
        <fuse-alert
            *ngIf="showAlertEditar"
            class="my-2"
            [name]="'alertModificar'"
            [appearance]="'soft'"
            [dismissible]="true"
            [showIcon]="false"
            [type]="alert.type"
            [@shake]="alert.type === 'error'">
            {{ alert.message }}
        </fuse-alert>
        <h1 class="font-bold text-center title-5">Editar</h1>

        <p class="text-center title-9 text-primary-black-01 mt-7">Usuario: {{ userModel.email }}</p>

        <form class="mt-5 mb-2" #formEditar="ngForm">
            <mat-form-field hideRequiredMarker class="w-full">
                <mat-label>Rut</mat-label>
                <input
                    matInput
                    type="text"
                    class="h-[26px]"
                    name="rut"
                    [(ngModel)]="userModel.rutDv"
                    placeholder="Ej. 12.345.678-9"
                    maxlength="12"
                    required
                    #rut="ngModel"
                    appRutValidation />
            </mat-form-field>
            <mat-form-field hideRequiredMarker class="w-full">
                <mat-label>Nombre usuario</mat-label>
                <input
                    matInput
                    type="text"
                    placeholder="Nombre usuario"
                    maxlength="50"
                    class="h-[26px]"
                    name="nombre"
                    [(ngModel)]="userModel.nombre"
                    pattern="^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]{1,50}$"
                    required
                    #nombreUsuario="ngModel" />
            </mat-form-field>
            <mat-form-field hideRequiredMarker appearance="fill" class="w-full">
                <mat-label>Rol</mat-label>
                <mat-select class="h-[54px]" required [(ngModel)]="userModel.rolId" #rol="ngModel" name="rol">
                    <mat-option *ngFor="let rol of roles" [value]="rol.id">
                        {{ rol.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <!-- <button mat-stroked-button class="flex items-center justify-center w-full h-10 mt-5 btn-md btn-primary" [color]="'primary'">
                <span>Resetear contraseña</span>
            </button> -->
            <button
                mat-stroked-button
                class="flex items-center justify-center w-full h-10 mt-5 btn-md btn-primary"
                [color]="'primary'"
                (click)="resetPasswordUser()"
                [disabled]="guardandoUser">
                <span>Resetear contraseña</span>
            </button>
            <button
                mat-flat-button
                class="flex items-center justify-center w-full h-10 mt-5 btn-md btn-primary"
                [color]="'primary'"
                (click)="guardarUser()"
                [disabled]="guardandoUser || !formEditar.valid">
                <span>Guardar Cambios</span>
                <!-- <mat-progress-spinner *ngIf="loginForm.disabled" [diameter]="24" [mode]="'indeterminate'">
					</mat-progress-spinner> -->
            </button>
        </form>
    </div>
</div>

<!-- Modal Baja -->
<section *ngIf="modalBaja" class="fixed inset-0 grid w-full h-full px-8 bg-opacity-50 bg-primary-black-01 z-999 place-items-center">
    <article class="max-w-[504px] bg-primary-white-01 rounded-2xl px-10 py-8 md:px-16 md:pt-18 md:pb-16 relative">
        <button
            class="absolute top-3 right-3 md:right-8 flex gap-3 items-center text-primary-blue-01 font-bold text-[10px]"
            (click)="closeModalEliminar()">
            CERRAR
            <div class="flex items-center justify-center w-6 h-6 mx-auto border rounded-full border-primary-blue-01">
                <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
            </div>
        </button>
        <h1 class="font-bold text-center title-5">Dar de baja</h1>

        <p class="my-5 text-center text-black paragraph-2 md:my-8">¿Está seguro de eliminar los usuarios seleccionados?</p>

        <button
            mat-flat-button
            class="flex items-center justify-center w-48 h-10 mx-auto mt-5 btn-md btn-primary"
            [color]="'primary'"
            (click)="borrarSeleccionados()"
            [disabled]="eliminandoDatos">
            <span>Eliminar</span>
            <!-- <mat-progress-spinner *ngIf="loginForm.disabled" [diameter]="24" [mode]="'indeterminate'">
					</mat-progress-spinner> -->
        </button>
    </article>
</section>
